var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EB5757",
    fillOpacity: 0.11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9.5H8.75H20.75",
    stroke: "#EB5757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 9.5C19.75 9.22386 19.5261 9 19.25 9C18.9739 9 18.75 9.22386 18.75 9.5H19.75ZM9.25 9.5C9.25 9.22386 9.02614 9 8.75 9C8.47386 9 8.25 9.22386 8.25 9.5H9.25ZM10.5 9.5C10.5 9.77614 10.7239 10 11 10C11.2761 10 11.5 9.77614 11.5 9.5H10.5ZM16.5 9.5C16.5 9.77614 16.7239 10 17 10C17.2761 10 17.5 9.77614 17.5 9.5H16.5ZM18.75 9.5V20H19.75V9.5H18.75ZM18.75 20C18.75 20.5523 18.3023 21 17.75 21V22C18.8546 22 19.75 21.1046 19.75 20H18.75ZM17.75 21H10.25V22H17.75V21ZM10.25 21C9.69772 21 9.25 20.5523 9.25 20H8.25C8.25 21.1046 9.14543 22 10.25 22V21ZM9.25 20V9.5H8.25V20H9.25ZM11.5 9.5V8H10.5V9.5H11.5ZM11.5 8C11.5 7.44772 11.9477 7 12.5 7V6C11.3954 6 10.5 6.89543 10.5 8H11.5ZM12.5 7H15.5V6H12.5V7ZM15.5 7C16.0523 7 16.5 7.44772 16.5 8H17.5C17.5 6.89543 16.6046 6 15.5 6V7ZM16.5 8V9.5H17.5V8H16.5Z",
    fill: "#EB5757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.25V17.75",
    stroke: "#EB5757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.25V17.75",
    stroke: "#EB5757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8ca9e571486e1cb991643daafb84f13f.svg";
export { ForwardRef as ReactComponent };